import { AbstractControl, ValidationErrors } from "@angular/forms";

export const iBanValidator = (control: AbstractControl): ValidationErrors | null => {
  const iban = control.value;
  return  /^([A-Z]{2}[ -]?[0-9]{2})(?=(?:[ -]?[A-Z0-9]){9,30}$)((?:[ -]?[A-Z0-9]{3,5}){2,7})([ -]?[A-Z0-9]{1,3})?$/.test(iban?.trim()) ? null : {iban};
};